import { TextField } from "@mui/material"
import { Box } from "@mui/system"
import { DesktopDatePicker, LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { IRootState } from "app/model"
import { getDateFnsAdapter, getDateWithMaxTime, getDateWithMinTime } from "app/util/date/tools/common"
import React from "react"
import { connect } from "react-redux"
import { MAX_TABLET_WIDTH_IN_PX } from "ui/model"

interface IDatePickerProps {
  label: string
  disabled?: boolean
  required?: boolean
  value: Date | null
  id?: string
  minDate?: Date
  maxDate?: Date
  minTime?: boolean
  maxTime?: boolean
  error?: string
  avoidDateInPast?: boolean
  onChange: (date: Date | null) => any
}

interface IDatePickerConnectProps {
  isMobile: boolean
}

const DatePickerFn = React.memo(
  ({
    label,
    disabled,
    required,
    value,
    error,
    id,
    minDate,
    maxDate,
    minTime,
    maxTime,
    isMobile,
    onChange,
    avoidDateInPast: disabledPastDate
  }: IDatePickerProps & IDatePickerConnectProps) => {
    const DatePicker = isMobile ? MobileDatePicker : DesktopDatePicker
    const getTimedValue = (date: Date | null): Date | null => {
      if (!date) {
        return date
      }
      if (minTime) {
        return getDateWithMinTime(date)
      } else if (maxTime) {
        return getDateWithMaxTime(date)
      }
      return date
    }
    return (
      <Box
        id={id}
        sx={{
          "& .date-picker": {
            "& input": {
              pt: ".6rem",
              pb: ".6rem"
            },
            "& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl": {
              top: "-.3rem"
            }
          }
        }}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateFnsAdapter()}>
          <DatePicker
            className="date-picker"
            label={required ? `${label} *` : label}
            value={value}
            minDate={disabledPastDate ? Date.now() : minDate || null}
            maxDate={maxDate}
            onChange={newValue => onChange(getTimedValue(newValue as any))}
            readOnly={disabled}
            disabled={disabled}
            renderInput={params => <TextField {...params} helperText={error || undefined} />}
          />
        </LocalizationProvider>
      </Box>
    )
  }
)

export const DatePicker = connect(
  (state: IRootState): IDatePickerConnectProps => ({
    isMobile: state.ui.container.width < MAX_TABLET_WIDTH_IN_PX
  })
)(DatePickerFn)
